import { Component, OnInit,Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { VesignDataService } from '../service/vesign-data.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-partner-child-cons-completeddocs',
  templateUrl: './partner-child-cons-completeddocs.component.html',
  styleUrls: ['./partner-child-cons-completeddocs.component.css']
})
export class PartnerChildConsCompleteddocsComponent implements OnInit {

  @Input() item = '';
  @Input() itemtaskid = '';
  DocId : number = 0;
  
  GciID: number = 0;
  
  EmailLogId: number = 0;
  EmailId: string = "";
  VendorConsDocList = [];
  VendorConsDocDropList = [];
  TaskId: number = 0;
  DocType: string = "";
  DocContent: any;
  params = {
    taskId: 0,
    gciId: 0
  };
  constructor(private dataService: VesignDataService<any>, private spinner: NgxSpinnerService,private route: ActivatedRoute) 
  {
    this.route.queryParams.subscribe(
      params=>{
        this.GciID=params.gciId;
        this.TaskId=params.taskId;

      });
   }

  ngOnInit(): void {
    this.ViewVendorConCompletedDocumentList(this.itemtaskid,this.item,0)
  }


  ViewVendorConCompletedDocumentList(taskId,EmailLogId,EmailId)
  {
    
    //console.log(this.item);
    this.EmailLogId = EmailLogId;
    this.EmailId = EmailId;
    if(this.VendorConsDocDropList.length != 0)
    {
      this.VendorConsDocDropList = [];
      this.DocType = '';
     
    }
    else{
    this.spinner.show(); 
    
    this.VendorConsDocList = [];
    this.VendorConsDocDropList = [];
    this.DocType = '';

    this.dataService.Get(environment.eSignApiUrl + "/api/VendorEsign/ViewVendorCompletedDocsList?TaskID=" + taskId +"&EmailLogId=" + EmailLogId, null)
      .subscribe(
        
        (response: any) => {
          this.VendorConsDocList = response; 
                   
          this.VendorConsDocList.forEach((value, index) => {
            if (this.DocType != value.doc_category) {                   
              {
                this.VendorConsDocDropList.push({ SNO: value.sno, DocCategory: value.doc_category, DocList: [] });
              }                      
              this.DocType = value.doc_category              
            }
             let latestIndex: any = this.VendorConsDocDropList.length - 1;            
             this.VendorConsDocDropList[latestIndex].DocList.push({ DocID: value.sno, DocCategory: value.doc_category, FilePath: value.filePath, IsEditable: (value.filePath.split('.').pop() == "aspx" || value.filePath.split('.').pop() == "asp") ? true : false , DocName: value.actual_Form_Name, TaskID : value.task_id, Signed: value.signed, FileContent: value.uploadedFileData, UploadedFileName: value.uploadedFileName,DocuSignStatus: value.docuSign_Status, envelopId:value.envelopId,documentId:value.documentId});
            // console.log(value.uploadedFileData);    
            });
          this.spinner.hide();
        },
        error => {
          console.log(error);
          this.spinner.hide();
        });
       // console.log(this.VendorConsDocDropList);    
    }
  }
    Passfilecontent()
    {

    }
    // CommonDownloadFile(item.documentId,item.envelopId,item.UploadedFileName,item.FileContent,item.DocuSignStatus,'0')
  CommonDownloadFile(documentId, envelopId, UploadedFileName, FileContent, DocuSignStatus,IsDownload )
  {
    //debugger
    if(FileContent!=null && DocuSignStatus=='Executed')
    {
      this.DownloadFile(UploadedFileName,FileContent,IsDownload);
    }
    else if(FileContent==null && DocuSignStatus=='Signed')
    {
      this.DownloadFileSigned(documentId,envelopId,UploadedFileName,IsDownload);
    }
    else if(FileContent!=null && DocuSignStatus=='Signed')
    {
      this.DownloadFile(UploadedFileName,FileContent,IsDownload);
    }
  }


  base64ToBlob(b64Data, contentType = '', sliceSize = 512) {
    b64Data = b64Data.replace(/\s/g, ''); //IE compatibility...
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  ViewUploadedFile(FileContent, UploadedFileName,IsDownload)
  {
    let mimeType;
    const selectedFileType = UploadedFileName.replace('.aspx','.pdf').split('.').pop();
    
    const FileType = [
      // { key: "jpg", value: 'image/jpg', IsDownload: "0" },
      // { key: "jpeg", value: 'image/jpeg', IsDownload: "0" },
      // { key: "png", value: 'image/png', IsDownload: "0" },
      { key: "pdf", value: 'application/pdf', IsDownload: "0" },
      // { key: "xlsx", value: 'application/vnd.ms-excel', IsDownload: "1" },
      // { key: "xls", value: 'application/vnd.ms-excel', IsDownload: "1" },
      // { key: "doc", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      // { key: "docx", value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', IsDownload: "1" },
      // { key: "msg", value: 'application/vnd.ms-outlook', IsDownload: "1" }
    ];

    mimeType = FileType.filter((value) => value.key == selectedFileType);
    
    if (mimeType.length > 0) {
      this.spinner.show();
      var blob = this.base64ToBlob(FileContent, mimeType[0].value);      
      if (IsDownload == "1") {
        var link = window.document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = UploadedFileName.replace('.aspx','.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.spinner.hide();
      }
      else {
        var url = window.URL.createObjectURL(blob);
        window.open(url);
        this.spinner.hide();
      }
    }
  }
  DownloadFile(filename: string, Doc: any,isDownloadorView : string) {  
    if(Doc != null){
     this.ViewUploadedFile(Doc, filename,isDownloadorView)
   }
  }

  DownloadFileSigned(documentId : number,envelopId:string  ,filename: string, isDownloadorView: string) {
    this.dataService.Post(environment.devEsignConsultantApiUrl + "/api/EmbeddedSigning/DocuSignGetSignedEnvelope?envelopId=" + envelopId+"&documentId="+documentId, null)
      .subscribe(
        (response: any) => {
          
          this.DocContent = response.data;
          this.ViewUploadedFile(this.DocContent, filename, isDownloadorView);
        });


  }

}
